<div class="container text-right">
    <h1 class=" text-center py-3 pb-4">اختر الخطة التي تناسبك</h1>

<section id="subscribe">
    <div class="row py-3 pb-5" id>
        <div class="col-lg-2">
            <div class="d-flex justify-content-center py-1">
                <p class="text-muted mt-3 mr-4" style="font-size: 14px;">شهر/</p>
                <h2 class="card-title   "> 39.99$</h2>
                
              </div>
              <div class="d-flex flex-column  row-hl " >
                <button  class="btn btn-lg  py-2 px-5 text-center text-white align-self-center item-hl active" style="  background-color: #4CB5FF;">اشترك الأن</button>
                
             </div>
        </div>
        <div class="col-lg-2">
            <div class="d-flex justify-content-center py-1">
                <p class="text-muted mt-3 mr-4" style="font-size: 14px;">شهر/</p>
                <h2 class="card-title   "> 19.99$</h2>
                
              </div>
              <div class="d-flex flex-column  row-hl " >
                <button  class="btn btn-lg  py-2 px-5 text-center text-dark align-self-center item-hl active">اشترك الأن</button>
                
             </div>
        </div>
        <div class="col-lg-2">
                <h2 class="card-title text-center mb-4 ">مجاني</h2>
                
              
              <div class="d-flex flex-column  row-hl " >
                <button  class="btn btn-lg  py-2 px-5 text-center text-dark align-self-center item-hl active">اشترك الأن</button>
                
             </div>
        </div>
        <div class="col-lg-6 ">
            <img class="align-self-center mr-5" width="20%" src="https://www.flaticon.com/svg/vstatic/svg/4072/4072626.svg?token=exp=1614716513~hmac=9f65141a8ca00f735de03ffc31ecb5a8" alt="sdsa">
        </div>
    </div>
</section>




      <!-- BORDERED TABLE -->
      <table class="table table-bordered text-center table-striped">
        <thead>
            <tr>
                <th>الاتاحه</th>
                <th>الاتاحه</th>
                <th>الاتاحه</th>
                <th class="tableFeat">المزايا المتوفرة</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th ><i class="fas fa-check fa-2x"></i></th>
                <td><i class="fas fa-check fa-2x"></i></td>
                <td><i class="fas fa-check fa-2x"></i></td>
                <td class="text-muted">عدد لا محدود من المنتجات</td>
            </tr>
            <tr>
                <th ><i class="fas fa-check fa-2x"></i></th>
                <td><i class="fas fa-check fa-2x"></i></td>
                <td><i class="fas fa-check fa-2x"></i></td>
                <td  class="text-muted">عدد لا محدود من الطلبات</td>
            </tr>
            <tr>
                <th ><i class="fas fa-check fa-2x"></i></th>
                <td><i class="fas fa-check fa-2x"></i></td>
                <td><i class="fas fa-check fa-2x"></i></td>
                <td  class="text-muted">عدد لا محدود من كوبونات التخفيض</td>
            </tr>
            <tr>
                <th ><i class="fas fa-check fa-2x"></i></th>
                <td><i class="fas fa-check fa-2x"></i></td>
                <td><i class="fas fa-check fa-2x"></i></td>
                <td  class="text-muted">استقبال اسئلة وتقييمات العملاء</td>
            </tr>
            <tr>
                <th ><i class="fas fa-check fa-2x"></i></th>
                <td><i class="fas fa-check fa-2x"></i></td>
                <td></td>
                <td  class="text-muted">عدد لا محدود من المنتجات</td>
            </tr>
            <tr>
                <th ><i class="fas fa-check fa-2x"></i></th>
                <td><i class="fas fa-check fa-2x"></i></td>
                <td></td>
                <td  class="text-muted">عدد لا محدود من المنتجات</td>
            </tr>
            <tr>
                <th ><i class="fas fa-check fa-2x"></i></th>
                <td></td>
                <td></td>
                <td  class="text-muted">عدد لا محدود من المنتجات</td>
            </tr>
            <tr>
                <th ><i class="fas fa-check fa-2x"></i></th>
                <td></td>
                <td></td>
                <td  class="text-muted">عدد لا محدود من المنتجات</td>
            </tr>
        </tbody>
    </table>


    <section id="subscribe">
        <div class="row py-3 pb-5" id>
            <div class="col-lg-2">
                <div class="d-flex justify-content-center py-1">
                    <p class="text-muted mt-3 mr-4" style="font-size: 14px;">شهر/</p>
                    <h2 class="card-title   "> 39.99$</h2>
                    
                  </div>
                  <div class="d-flex flex-column  row-hl " >
                    <button  class="btn btn-lg btn-primary py-2 px-5 text-center text-white align-self-center item-hl active">اشترك الأن</button>
                    
                 </div>
            </div>
            <div class="col-lg-2">
                <div class="d-flex justify-content-center py-1">
                    <p class="text-muted mt-3 mr-4" style="font-size: 14px;">شهر/</p>
                    <h2 class="card-title   "> 19.99$</h2>
                    
                  </div>
                  <div class="d-flex flex-column  row-hl " >
                    <button  class="btn btn-lg   py-2 px-5 text-center text-dark align-self-center item-hl ">اشترك الأن</button>
                    
                 </div>
            </div>
            <div class="col-lg-2">
                    <h2 class="card-title text-center mb-4 ">مجاني</h2>
                    
                  
                  <div class="d-flex flex-column  row-hl " >
                    <button   class="btn btn-lg   py-2 px-5 text-center text-dark align-self-center item-hl ">اشترك الأن</button>
                    
                 </div>
            </div>
         
        </div>
    </section>
</div>
